/* ============================================================
   PETSLIFY MEMORIAL WALL
   Form handling: photo upload to Cloudinary (on photo select),
   progress bar, dynamic submit button, success state transition.
   
   Uploads happen on file selection so Shopify's CAPTCHA can
   attach properly during the user-clicked submit.
   ============================================================ */

(function () {
  'use strict';

  var config = window.PetslifyMemorialConfig || {};
  var CLOUD_NAME = config.cloudName;
  var UPLOAD_PRESET = config.uploadPreset;
  var FOLDER = config.folder || 'memorial-wall';

  var MAX_FILE_SIZE_MB = 10;
  var MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
  var ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/heic', 'image/heif', 'image/webp'];

  function init() {
    var formWrapper = document.querySelector('[data-memorial-form]');
    if (!formWrapper) return;

    var formEl = formWrapper.querySelector('form');
    if (!formEl) return;

    var photoInput = formWrapper.querySelector('[data-memorial-photo-input]');
    var photoUrlInput = formWrapper.querySelector('[data-memorial-photo-url]');
    var photoLabelIdle = formWrapper.querySelector('.memorial-form__photo-label-idle');
    var photoLabelSelected = formWrapper.querySelector('.memorial-form__photo-label-selected');
    var photoFilename = formWrapper.querySelector('[data-memorial-photo-filename]');
    var photoChange = formWrapper.querySelector('[data-memorial-photo-change]');
    var photoPreview = formWrapper.querySelector('[data-memorial-photo-preview]');
    var photoPreviewImg = formWrapper.querySelector('[data-memorial-photo-preview-img]');
    var photoError = formWrapper.querySelector('[data-memorial-photo-error]');
    var petNameInput = formWrapper.querySelector('[data-memorial-field="pet_name"]');
    var emailInput = formWrapper.querySelector('[data-memorial-field="email"]');
    var submitBtn = formWrapper.querySelector('[data-memorial-submit]');
    var progressEl = formWrapper.querySelector('[data-memorial-progress]');
    var progressFill = formWrapper.querySelector('[data-memorial-progress-fill]');
    var progressLabel = formWrapper.querySelector('[data-memorial-progress-label]');
    var successEl = formWrapper.querySelector('[data-memorial-form-success]');
    var successName = formWrapper.querySelector('[data-memorial-success-name]');
    var successEmail = formWrapper.querySelector('[data-memorial-success-email]');

    var uploadInProgress = false;
    var uploadFailed = false;

    // Open-form button in the hero — smooth scroll to the form
    var openButtons = document.querySelectorAll('[data-memorial-form-open]');
    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var formSection = document.querySelector('[data-memorial-form-section]');
        if (formSection) {
          var offsetTop = formSection.getBoundingClientRect().top + window.pageYOffset - 40;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
          setTimeout(function () {
            if (petNameInput) petNameInput.focus();
          }, 600);
        }
      });
    });

    // ========== DYNAMIC SUBMIT BUTTON TEXT ==========
    var baseButtonText = submitBtn.textContent;
    function updateSubmitText() {
      if (uploadInProgress) {
        submitBtn.textContent = 'Uploading photo, please wait...';
        return;
      }
      var petName = (petNameInput.value || '').trim();
      if (petName) {
        submitBtn.textContent = 'Share ' + petName + ' with the wall';
      } else {
        submitBtn.textContent = baseButtonText.replace(/\[pet name\]/i, 'them');
      }
    }
    updateSubmitText();
    petNameInput.addEventListener('input', updateSubmitText);

    // ========== PHOTO SELECTION → IMMEDIATE UPLOAD ==========
    photoInput.addEventListener('change', function (e) {
      hidePhotoError();
      var file = e.target.files && e.target.files[0];
      if (!file) {
        resetPhoto();
        return;
      }

      if (ALLOWED_TYPES.indexOf(file.type) === -1) {
        showPhotoError('This file type is not supported. Please use a JPG, PNG, HEIC, or WebP photo.');
        resetPhoto();
        return;
      }

      if (file.size > MAX_FILE_SIZE_BYTES) {
        showPhotoError('This photo is larger than ' + MAX_FILE_SIZE_MB + ' MB. Please choose a smaller one.');
        resetPhoto();
        return;
      }

      showPhotoSelected(file);
      startUpload(file);
    });

    if (photoChange) {
      photoChange.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        resetPhoto();
        photoInput.click();
      });
    }

    function showPhotoSelected(file) {
      photoLabelIdle.hidden = true;
      photoLabelSelected.hidden = false;
      photoFilename.textContent = file.name;

      var reader = new FileReader();
      reader.onload = function (evt) {
        photoPreviewImg.src = evt.target.result;
        photoPreview.hidden = false;
      };
      reader.readAsDataURL(file);
    }

    function resetPhoto() {
      photoInput.value = '';
      photoUrlInput.value = '';
      photoLabelIdle.hidden = false;
      photoLabelSelected.hidden = true;
      photoPreview.hidden = true;
      photoPreviewImg.src = '';
      hideProgress();
      uploadInProgress = false;
      uploadFailed = false;
      enableSubmit();
      updateSubmitText();
    }

    function showPhotoError(msg) {
      photoError.textContent = msg;
      photoError.hidden = false;
    }

    function hidePhotoError() {
      photoError.hidden = true;
      photoError.textContent = '';
    }

    // ========== CLOUDINARY UPLOAD ==========
    function startUpload(file) {
      if (!CLOUD_NAME || !UPLOAD_PRESET) {
        showPhotoError('Upload service is not configured. Please contact us directly.');
        return;
      }

      uploadInProgress = true;
      uploadFailed = false;
      disableSubmit();
      updateSubmitText();
      showProgress(0, 'Uploading photo...');

      var xhr = new XMLHttpRequest();
      var url = 'https://api.cloudinary.com/v1_1/' + CLOUD_NAME + '/image/upload';
      xhr.open('POST', url, true);

      xhr.upload.addEventListener('progress', function (evt) {
        if (evt.lengthComputable) {
          var percent = Math.round((evt.loaded / evt.total) * 100);
          showProgress(percent, 'Uploading photo... ' + percent + '%');
        }
      });

      xhr.onload = function () {
        uploadInProgress = false;
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var response = JSON.parse(xhr.responseText);
            if (response.secure_url) {
              photoUrlInput.value = response.secure_url;
              showProgress(100, 'Photo ready.');
              setTimeout(hideProgress, 1500);
              enableSubmit();
              updateSubmitText();
            } else {
              handleUploadError('The upload completed but no photo URL was returned.');
            }
          } catch (err) {
            handleUploadError('We received an invalid response from the upload service.');
          }
        } else {
          handleUploadError('The upload failed (status ' + xhr.status + ').');
        }
      };

      xhr.onerror = function () {
        uploadInProgress = false;
        handleUploadError('A network error interrupted the upload.');
      };

      xhr.ontimeout = function () {
        uploadInProgress = false;
        handleUploadError('The upload took too long and timed out.');
      };

      xhr.timeout = 60000;

      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', UPLOAD_PRESET);
      if (FOLDER) formData.append('folder', FOLDER);

      xhr.send(formData);
    }

    function handleUploadError(msg) {
      uploadFailed = true;
      showPhotoError(msg + ' Please try selecting the photo again.');
      hideProgress();
      enableSubmit();
      updateSubmitText();
      // Clear the photo URL so form won't submit with stale data
      photoUrlInput.value = '';
      // Reset visual state
      photoLabelIdle.hidden = false;
      photoLabelSelected.hidden = true;
      photoPreview.hidden = true;
      photoInput.value = '';
    }

    // ========== FORM SUBMISSION ==========
    formEl.addEventListener('submit', function (e) {
      // If upload is still in progress, block submission
      if (uploadInProgress) {
        e.preventDefault();
        showPhotoError('Your photo is still uploading. Please wait a moment.');
        return;
      }

      // If no photo URL, block and ask for photo
      if (!photoUrlInput.value) {
        e.preventDefault();
        showPhotoError('Please select a photo before submitting.');
        photoInput.focus();
        return;
      }

      // All good — save name/email for success panel on next page load
      try {
        sessionStorage.setItem('memorial_success_pet_name', (petNameInput.value || '').trim());
        sessionStorage.setItem('memorial_success_email', (emailInput.value || '').trim());
      } catch (err) {
        // Non-fatal
      }

      // Let the form submit normally — Shopify CAPTCHA will attach
      disableSubmit();
      submitBtn.textContent = 'Submitting...';
    });

    // ========== PROGRESS BAR ==========
    function showProgress(percent, label) {
      progressEl.hidden = false;
      progressFill.style.width = percent + '%';
      progressLabel.textContent = label;
    }

    function hideProgress() {
      progressEl.hidden = true;
      progressFill.style.width = '0%';
    }

    function disableSubmit() {
      submitBtn.disabled = true;
    }

    function enableSubmit() {
      submitBtn.disabled = false;
    }

    // ========== SUCCESS STATE ==========
    if (successEl && !successEl.hidden) {
      try {
        var savedName = sessionStorage.getItem('memorial_success_pet_name');
        var savedEmail = sessionStorage.getItem('memorial_success_email');
        if (savedName && successName) successName.textContent = savedName;
        if (savedEmail && successEmail) successEmail.textContent = savedEmail;
        sessionStorage.removeItem('memorial_success_pet_name');
        sessionStorage.removeItem('memorial_success_email');
      } catch (e) {
        // Non-fatal
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();